// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.layout-admin_main__u5sf\\+ {
  width: 80%;
  height: 100%;
  margin-inline: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/layout-admin/index.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".main {\n  width: 80%;\n  height: 100%;\n  margin-inline: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `layout-admin_main__u5sf+`
};
export default ___CSS_LOADER_EXPORT___;
